import { situacoes } from '@/core/constants'

export default {
	methods: {
		fecharModalSignatarios() {
			this.signatarios = []
			this.exibirModalSignatarios = false
		},
		async tratarEventoVisualizarSignatarios(idDocumento) {
			const documento = this.documentos.find((documento) => documento.id === idDocumento)
			this.signatarios = documento.signatarios.itens
			this.exibirModalSignatarios = true
			this.tituloModal = 'Signatários'
		},
		async convidarSignatarios(emailsSignatarios) {
			await this.$store.dispatch(this.actionsSignatarios.CONVIDAR_SIGNATARIOS, {
				idDocumento: this.idAssociacao,
				emailsSignatarios,
			})
			const documento = this.documentos.find((documento) => documento.id === this.idAssociacao)
			const documentoSignatario = await this.buscarSignatariosDocumento([documento])
			this.$set(this.documentos, this.documentos.indexOf(documento), documentoSignatario[0])
			this.mostrarNotificacaoSucesso('Signatários Convidados com Sucesso')
			this.fecharModal()
		},
		async buscarSignatariosDocumento(documentos) {
			let novoArray = []
			if (documentos !== null) {
				for (const documento of documentos) {
					if (documento.situacao && documento.situacao !== situacoes.DOCUMENTO.CRIADO.value) {
						const resultado = await this.$store.dispatch(
							this.actionsSignatarios.BUSCAR_SIGNATARIOS,
							documento.id,
						)
						const documentoNovo = Object.assign({}, documento, {
							signatarios: resultado,
						})
						novoArray.push(documentoNovo)
					} else {
						novoArray.push(documento)
					}
				}
			}

			return novoArray
		},
		fecharModal() {
			this.exibirModalConvidarSignatarios = false
		},
		tratarEventoExcluirSignatario({ idAssociacao, signatario }) {
			this.exibirModalConvidarSignatarios = false
			this.idAssociacao = idAssociacao
			this.emailSignatarioExclusao = signatario.email
			this.tituloModal = 'Atenção! Deseja excluir este signatário?'
			this.mensagemConfirmacaoModal =
				'Após a confirmação, o signatário será excluído e não poderá assinar o documento!'
			this.confirmarAcaoModal = this.excluirSignatario
			this.cancelarAcaoModal = this.cancelarAcaoExcluirSignatario
			this.fecharAcaoModal = this.cancelarAcaoExcluirSignatario
			this.exibirModalConfirmacao = true
		},
		tratarEventoConvidarSignatarios({ idAssociacao, titulo }) {
			this.idAssociacao = idAssociacao
			this.exibirModalConvidarSignatarios = true
			this.tituloModal = 'Convite'
			this.tituloDocumento = titulo
		},
		async excluirSignatario() {
			await this.$store.dispatch(this.actionsSignatarios.SIGNATARIOS.EXCLUIR, {
				idDocumento: this.idAssociacao,
				emailsSignatarios: this.emailSignatarioExclusao,
			})
			this.mostrarNotificacaoSucesso('Signatário excluido com sucesso')
			this.exibirModalConvidarSignatarios = false
			const documento = this.getDocumentoPorPropriedade('id', this.idAssociacao)
			const documentoSignatario = await this.buscarSignatariosDocumento([documento])
			this.$set(this.documentos, this.documentos.indexOf(documento), documentoSignatario[0])
			this.tratarEventoConvidarSignatarios({ idAssociacao: this.idAssociacao, titulo: this.tituloDocumento })
			this.cancelarAcaoExcluirSignatario()
		},
		getDocumentoPorPropriedade(propriedade, valor) {
			return this.documentos.find((documento) => documento[propriedade] === valor)
		},
		cancelarAcaoExcluirSignatario() {
			this.exibirModalConfirmacao = false
			this.tratarEventoConvidarSignatarios({ idAssociacao: this.idAssociacao, titulo: this.tituloDocumento })
		},
	},
}
